import React, { useEffect } from 'react';
import Header from 'components/Common/Header/Header';
import { Outlet, useLocation } from 'react-router-dom';

const ChatLayout: React.FC = () => {
	const location = useLocation();
	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'instant',
		});
	}, [location?.pathname]);

	return (
		<>
			<Header />
			<Outlet />
		</>
	);
};

export default ChatLayout;
